import DealRedeemedInfo from './DealRedeemedInfo';
export default DealRedeemedInfo;